import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en.json';
import plTranslation from './locales/pl.json';

const localStorageKey = 'language';

const getInitialLanguage = () => {
    const savedLanguage = localStorage.getItem(localStorageKey);
    if (savedLanguage) {
        return savedLanguage;
    }

    const browserLanguage = navigator.language;
    if (browserLanguage.startsWith('pl')) {
        return 'pl';
    }

    return 'en';
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation
            },
            pl: {
                translation: plTranslation
            }
        },
        lng: getInitialLanguage(),
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        detection: {
            lookupLocalStorage: localStorageKey,
            caches: ['localStorage']
        }
    });

export default i18n;
